module.exports = __webpack_public_path__ + "img/hej-bm.6b79b426.png";